<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 2l2.9 6.26 6.9.74-5 5.18L18.2 21 12 17.27 5.8 21l1.4-6.82-5-5.18 6.9-.74L12 2Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
